import React, { useState } from "react"

import { Grid } from "../Grid"
import { forwardRef } from "../../Hooks"
import { useIsomorphicLayoutEffect } from "../../../utils/hooks"
import { isBrowser } from "../../../utils/browser"

const resizeGridItem = item => {
  const grid = document.getElementsByClassName("grid")[0]

  const gridStyle = window.getComputedStyle(grid)
  const rowHeight = parseInt(gridStyle.getPropertyValue("grid-auto-rows")) || 0
  const rowGap = parseInt(gridStyle.getPropertyValue("grid-row-gap")) || 0

  const rowSpan = Math.ceil(
    (item.querySelector(".content").getBoundingClientRect().height + rowGap) /
      (rowHeight + rowGap)
  )

  item.style.gridRowEnd = "span " + rowSpan
}

const resizeAllGridItems = (height, setHeight, setOpacity) => {
  const grid = document.getElementsByClassName("grid")[0]

  if (!grid || height === grid?.clientHeight) return

  setHeight(grid.clientHeight)

  Array.from(document.getElementsByClassName("item")).forEach(element => {
    resizeGridItem(element)
  })

  if (typeof setOpacity == "function") setOpacity(1)
}

const InternalMasonryGrid = forwardRef((props, ref) => {
  const [height, setHeight] = useState(0)
  const [opacity, setOpacity] = useState(0)

  useIsomorphicLayoutEffect(() => {
    setOpacity(0)
  }, [])

  useIsomorphicLayoutEffect(() => {
    if (isBrowser) {
      setOpacity(0)
      resizeAllGridItems(0, setHeight)

      setTimeout(() => {
        setOpacity(1)
      }, 0)
    }
  }, [])

  useIsomorphicLayoutEffect(() => {
    if (isBrowser) {
      window.addEventListener(
        "resize",
        resizeAllGridItems.bind(null, height, setHeight, setOpacity)
      )

      return () => window.removeEventListener("resize", resizeAllGridItems)
    }
  }, [height])

  useIsomorphicLayoutEffect(() => {
    if (isBrowser) {
      const intervalId = setInterval(
        () => resizeAllGridItems(height, setHeight, setOpacity),
        300
      )
      return () => {
        clearInterval(intervalId)
      }
    }
  }, [height])

  return <Grid opacity={opacity} className="grid" ref={ref} {...props} />
})

export const MasonryGrid = forwardRef(({ disableMasonry, ...props }, ref) => {
  const additionalProps = { className: "grid" }

  if (disableMasonry) return <Grid ref={ref} {...additionalProps} {...props} />

  return <InternalMasonryGrid ref={ref} {...additionalProps} {...props} />
})
